import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  CircularProgress,
} from '@mui/material';
import { useGlobal } from '../contexts/GlobalContext';
import { useBuild } from '../contexts/BuildContext';

const SemanticSearchQuery = () => {
  const { mergeCurrentContext } = useGlobal();
  const { searchApi } = useBuild();
  
  // Form state
  const [searchQuery, setSearchQuery] = useState('');
  
  // Query execution state
  const [isExecuting, setIsExecuting] = useState(false);

  useEffect(() => {
    mergeCurrentContext({
      queryBeingBuilt: { searchQuery },
    });
    return () => mergeCurrentContext({ queryBeingBuilt: undefined });
  }, [searchQuery, mergeCurrentContext]);

  const handleExecuteQuery = async () => {
    if (!searchQuery.trim()) {
      alert('Please enter a search query');
      return;
    }

    const payload = {
      text: searchQuery.trim(),
    };
    
    console.log('Semantic Search Query Payload:', payload);
    
    try {
      setIsExecuting(true);
      const response = await searchApi.generateSemanticSearchCandidates(payload);
      console.log('API Response:', response);
      // Results are automatically stored in context by the API method
    } catch (error) {
      console.error('Error executing semantic search query:', error);
      // Error is automatically handled by the API method in context
    } finally {
      setIsExecuting(false);
    }
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Semantic Search Query
      </Typography>
      
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          Enter your search query to find semantically similar content:
        </Typography>
        
        <TextField
          label="Search Query"
          multiline
          rows={8}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Enter your search query here..."
          variant="outlined"
          sx={{ flex: 1 }}
        />
      </Box>

      {/* Execute Button */}
      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={handleExecuteQuery}
          disabled={!searchQuery.trim() || isExecuting}
          sx={{ minWidth: 200 }}
        >
          {isExecuting ? (
            <>
              <CircularProgress size={20} sx={{ mr: 1 }} />
              Executing...
            </>
          ) : (
            'Execute Query'
          )}
        </Button>
      </Box>
    </Box>
  );
};

export default SemanticSearchQuery;
